import React from "react";

export default ({ result }) => {
        
        var snippet = result.body_content.snippet.replace(/^[^A-Z0-1a-z\<]+/,'');
        var elipses = ''
        if(!result.body_content.snippet.replace(/<\/?em>/gi,'').trim().match(/^[A-Z]/)){
            elipses = '... ';
        }

        if(result.meta_keywords.raw.includes('decision')){
            var author, public_domain
            if(result.author == null){ author = "" }
            else{ author = <span className="decision-author">{result.author.raw}</span> }

            if(result.public_domain == null){ public_domain = "" }
            else{ public_domain = <span className="decision-pdcite">{result.public_domain.raw}</span> }
            
            return(
                <div className="result result-decision">
                        <h3><a href={result.url.raw}>{result.title.raw}</a></h3>
                        {public_domain}
                        {author}
                        <p dangerouslySetInnerHTML={{ __html: elipses + snippet + ' ...' }}></p>
                </div>
            )
        }
        else if (result.meta_keywords.raw.includes('forms')){
            return(
                <div className="result result-forms"><h3><a href={result.url.raw}>{result.title.raw}</a></h3><p dangerouslySetInnerHTML={{ __html: elipses + snippet + ' ...'}}></p></div>
            )
        }
        else if (result.meta_keywords.raw.includes('artwork')){
            var thumb = '';
            if(typeof result.thumbnail != 'undefined'){
                thumb = <img src={result.thumbnail.raw} />
            }
            
            return(
                <div className="result result-artwork result-thumbnail"><h3><a href={result.url.raw}>{result.title.raw}</a></h3>{thumb}<p dangerouslySetInnerHTML={{ __html: elipses + snippet + ' ...'}}></p></div>
            )
        }
        else if (result.meta_keywords.raw.includes('biography')){
            return(
                <div className="result result-biography"><h3><a href={result.url.raw}>{result.title.raw}</a></h3><p dangerouslySetInnerHTML={{ __html: elipses + snippet + ' ...'}}></p></div>
            )
        }
        else if(result.thumbnail){
            return(
                <div className="result result-thumbnail"><h3><a href={result.url.raw}>{result.title.raw}</a></h3><img src={result.thumbnail.raw} /><p dangerouslySetInnerHTML={{ __html: elipses + snippet + ' ...'}}></p></div>
            )
        }
        else{
            return (<div className="result"><h3><a href={result.url.raw}>{result.title.raw}</a></h3><p dangerouslySetInnerHTML={{ __html: elipses + snippet + ' ...' }}></p></div>)
        }
};